import ProductsModal from './ProductsModal';

export default ProductsModal;
